import React from 'react';

export const DeepSeekIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#4F46E5" opacity="0.2"/>
    <path d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 8V12L15 15" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="2" fill="#4F46E5"/>
  </svg>
);

export const ZhipuIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#0066FF" opacity="0.2"/>
    <path d="M12 6L14 10H18L15 13L16 17L12 14L8 17L9 13L6 10H10L12 6Z" fill="#0066FF"/>
    <circle cx="12" cy="12" r="3" fill="#0066FF" opacity="0.5"/>
  </svg>
);

export const MoonshotIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#7C3AED" opacity="0.2"/>
    <path d="M16 8C16 11.3137 13.3137 14 10 14C9.38758 14 8.80348 13.8986 8.25956 13.7126C9.61736 14.5327 11.2513 15 13 15C16.866 15 20 11.866 20 8C20 7.29877 19.8727 6.62656 19.6393 6" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="13" cy="9" r="1.5" fill="#7C3AED"/>
  </svg>
);

export const QwenIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#FF6A00" opacity="0.2"/>
    <path d="M8 9H16M8 12H16M8 15H13" stroke="#FF6A00" strokeWidth="2" strokeLinecap="round"/>
    <rect x="6" y="6" width="12" height="12" rx="2" stroke="#FF6A00" strokeWidth="2"/>
  </svg>
);

export const ErnieIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#2932E1" opacity="0.2"/>
    <path d="M9 9L12 6L15 9M9 15L12 18L15 15M6 12H18" stroke="#2932E1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="2" fill="#2932E1"/>
  </svg>
);

export const HunyuanIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#00B96B" opacity="0.2"/>
    <circle cx="12" cy="12" r="4" stroke="#00B96B" strokeWidth="2"/>
    <circle cx="12" cy="12" r="2" fill="#00B96B"/>
    <path d="M12 2V4M12 20V22M2 12H4M20 12H22" stroke="#00B96B" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const DoubaoIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#165DFF" opacity="0.2"/>
    <ellipse cx="12" cy="12" rx="6" ry="8" stroke="#165DFF" strokeWidth="2"/>
    <circle cx="9" cy="10" r="1.5" fill="#165DFF"/>
    <circle cx="15" cy="10" r="1.5" fill="#165DFF"/>
    <path d="M9 15Q12 18 15 15" stroke="#165DFF" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const OpenAIIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#10A37F" opacity="0.2"/>
    <path d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12" stroke="#10A37F" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 6V8M12 16V18M8 12H6M16 12H18" stroke="#10A37F" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="12" r="2" fill="#10A37F"/>
  </svg>
);

export const AnthropicIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#D97757" opacity="0.2"/>
    <path d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17" stroke="#D97757" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7" stroke="#D97757" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="12" r="1.5" fill="#D97757"/>
  </svg>
);

export const GoogleAIIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#4285F4" opacity="0.2"/>
    <path d="M12 8C9.79086 8 8 9.79086 8 12C8 13.1046 8.44772 14.1056 9.17157 14.8284" stroke="#4285F4" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14.8284 14.8284C15.5523 14.1056 16 13.1046 16 12" stroke="#EA4335" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 12C16 10.8954 15.5523 9.89443 14.8284 9.17157" stroke="#FBBC05" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14.8284 9.17157C14.1056 8.44772 13.1046 8 12 8" stroke="#34A853" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const CustomIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" fill="#6B7280" opacity="0.2"/>
    <path d="M12 8V16M8 12H16" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="12" r="3" stroke="#6B7280" strokeWidth="2"/>
  </svg>
);
